import type { ReactNode } from "react";
export default function AccountPage({
  title,
  children,
}: {
  title: ReactNode;
  children: ReactNode;
}) {
  return (
    <main className="mx-auto w-full max-w-6xl px-4 py-6 md:px-6 md:py-8">
      <header className="mb-6">{title}</header>
      {children}
    </main>
  );
}
